export default __webpack_public_path__ + "static/media/actify_text_logo.0f1a5ca7.svg";